import React from "react"
import SaleStage from "../components/SaleStage"

class Step5SS extends React.Component {
    render() {
        const { client, updateClient } = this.props;
        const { letterOfGuarantee={} } = (client && client.stages_of_sale) || {};

        const {
            cashPayment,
            bankFinancing,
            pagIbigFinancing,
            eightyPercentHouseConstruction,
            deedOfAbsoluteSaleFile,
            deedOfAbsoluteSaleDate,
            letterOfGuaranteeFile,
            deedOfReconveyance,
            deedOfReconveyanceDate,
            deedOfUndertakingFile,
            deedOfUndertakingDate,
            moaAndTrust,
            moaAndTrustDate,
            isCompleted,
            completionDate,
            others=[]
        } = letterOfGuarantee;

        const step5Fields = [
            { key: 'cashPayment', type: 'toggle', label: 'Cash Payment', value: cashPayment},
            { key: 'bankFinancing', type: 'toggle', label: 'Bank Financing', value: bankFinancing},
            { key: 'pagIbigFinancing', type: 'toggle', label: 'PAG-IBIG Financing', value: pagIbigFinancing},
            { key: 'eightyPercentHouseConstruction', type: 'toggle', label: 'Eighty Percent House Construction', value: eightyPercentHouseConstruction},
            { key: 'deedOfAbsoluteSaleFile', type: 'file', label: 'Deed Of Absolute Sale File', value: deedOfAbsoluteSaleFile},
            { key: 'deedOfAbsoluteSaleDate', type: 'date', label: 'Deed Of Absolute Sale Date', value: deedOfAbsoluteSaleDate},
            { key: 'letterOfGuaranteeFile', type: 'file', label: 'Letter of Guarantee', value: letterOfGuaranteeFile},
            { key: 'deedOfReconveyance', type: 'file', label: 'Deed of Reconveyance', value: deedOfReconveyance},
            { key: 'deedOfReconveyanceDate', type: 'date', label: 'Deed of Reconveyance Date', value: deedOfReconveyanceDate},
            { key: 'deedOfUndertakingFile', type: 'file', label: 'Deed of Undertaking', value: deedOfUndertakingFile},
            { key: 'deedOfUndertakingDate', type: 'date', label: 'Deed of Undertaking Date', value: deedOfUndertakingDate},
            { key: 'moaAndTrust', type: 'file', label: 'MOA and TRUST', value: moaAndTrust},
            { key: 'moaAndTrustDate', type: 'date', label: 'MOA and TRUST Date', value: moaAndTrustDate},
        ]

        return (
            !!client ? <SaleStage 
                title="Letter of Guarantee"
                fields={step5Fields}
                isCompleted={isCompleted}
                completionDate={completionDate}
                client={client}
                stage="letterOfGuarantee"
                updateClient={updateClient}
                others={others}
                previousStep={this.props.previousStep}
                nextStep={this.props.nextStep}
            /> : null
        )
    }
}

export default Step5SS
